import { FormControlLabel, Grid, Radio, TextField, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { FormikProps } from "formik";
import { getHelperText } from 'utils/formik_utils';

interface RadioInputProps {
  label: string;
  value: string;
  formik: FormikProps<any>;
  conditionalFieldName?: string;
  conditionalFieldLabel?: string;
  conditionalFieldFormikName?: string;
  conditionalFieldTitle?: string;
}

export const RadioInput: React.FC<RadioInputProps> = ({
  label,
  value,
  formik,
  conditionalFieldName,
  conditionalFieldLabel,
  conditionalFieldFormikName,
  conditionalFieldTitle,
}) => {
  const fieldValue = formik.values.landCategory;
  const isConditionalFieldVisible = fieldValue === conditionalFieldName;

  // reuse helper from utils

  return (
    <Box>
      <FormControlLabel
        value={value}
        control={<Radio />}
        label={label}
      />
      {isConditionalFieldVisible && conditionalFieldFormikName && (
        <Grid>
          <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
            {conditionalFieldTitle ?? conditionalFieldLabel}
          </Typography>
          <TextField
            name={conditionalFieldFormikName}
            value={formik.values[conditionalFieldFormikName] || ''}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={
              Boolean(formik.touched[conditionalFieldFormikName]) &&
              Boolean(formik.errors[conditionalFieldFormikName])
            }
            helperText={
              formik.touched[conditionalFieldFormikName] &&
                formik.errors[conditionalFieldFormikName]
                ? getHelperText(formik.errors, formik.touched, conditionalFieldFormikName)
                : ''
            }
            sx={{ width: '300px' }}
          />

        </Grid>
      )}
    </Box>
  );
};

// Export small pure helper for testing visibility logic
export const isConditionalVisible = (fieldValue: any, conditionalFieldName?: any) => {
  return fieldValue === conditionalFieldName;
};
